export default "__VITE_ASSET__DhN9WFs0__"